module.exports = __webpack_public_path__ + "static/media/02 Generali Sprzęt Rolniczy Karta produktu.f0bc58fe.pdf";